import {assembleReportJobQuery} from './shared/reportJobFunctions';
import {makeSystemModePath, setSystemToLowercase} from './shared/serverFunctions';
import {preProcessData} from './restClientPreProcess';

/**
 * VIP Usage                            - VIP Usage Report (Dashboard)
 * Recent Transactions                  - Recent Transactions Report (Dashboard)
 * Detailed Sales                       - Detailed Sales Reports
 * Item Sales by Date                   - Item Sales Reports
 * Item Returns by Date                 - Item Sales Reports
 * Sales Tax Audit                      - Sales Tax Audit Reports
 * Transactions by Day                  - Daily Sales Reports
 * Sales Comparison by Range            - Sales Comparison Reports
 * Sales Comparison by Location/Range   - Sales Comparison Reports (Location)
 * Scheduled Reports                    - Scheduled Reports
 * Report Jobs                          - Report Jobs
 * VIP Points and Products              - VIP Trends Reports
 * VIP Customers                        - VIP Trends Reports (Location)
 * Transfer Item Totals                 - Inventory Transfer Log Report
 * Location Open/Close Logs             - Location/Register Log Report
 * Register Open/Close Logs             - Location/Register Log Report
 * Register Log Info                    - Location/Register Log Report
 * Zero Days                            - Settlement Reports (Inventory), Inventory Log Report
 * Inventory by Zero Day                - Settlement Reports (Inventory), Inventory Log Report
 * Final Audit(s) by Zero Day           - Settlement Reports (Inventory)
 * Default Prices by Product Type       - Settlement Reports (Inventory), Inventory Log Report
 * Sales Summary by Zero Day            - Settlement Reports (Sales)
 * Inventory Get Incoming Item Totals   - Inventory Log Report
 * Render Report                        - Scheduled Reports, Combined Sales
 * Credit Card Transaction Search       - Credit Card Transaction Search Report
 */
export const RESOURCES = {
    'SalesLogByDate': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Sales Log by date',
                'uri': localStorage.getItem('server') + '/api/v5/report/sales/' + systemMode + '/salesLogByDateRange/' + params.start_date + '/' + params.start_time + '/' + params.end_date + '/' + params.end_time + '/' + params.offset
            }
        }
    },
    'SalesLogLocationByDate': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Sales Log by date',
                'uri': localStorage.getItem('server') + '/api/v5/report/sale/' + systemMode + '/' + params.location_id + '/salesLogLocationByDateRange/' + params.start_date + '/' + params.start_time + '/' + params.end_date + '/' + params.end_time + '/' + params.offset
            }
        }
    },
    'SaleLogBySeq': {
        GET_LIST: function (sale_seq) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Sales Log by Sale Sequence',
                'uri': localStorage.getItem('server') + '/api/v5/report/sales/' + systemMode + '/salesLogSaleSeq/' + sale_seq
            }
        }
    },
    'TransactionLogPaymentBySeq': {
        GET_LIST: function (payment_seq) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Transaction Log by Payment Sequence',
                'uri': localStorage.getItem('server') + '/api/v5/report/payments/' + systemMode + '/paymentLogbyPaymentSeq/' + payment_seq
            }
        }
    },
    'TransactionLogByDate': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Transaction Log by date',
                'uri': localStorage.getItem('server') + '/api/v5/report/payments/' + systemMode + '/paymentLogByDateRange/' + params.start_date + '/' + params.start_time + '/' + params.end_date + '/' + params.end_time + '/' + params.offset
            }
        }
    },
    'TransactionLogLocationByDate': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Transaction Log by date',
                'uri': localStorage.getItem('server') + '/api/v5/report/payment/' + systemMode + '/' + params.location_id + '/paymentLogLocationByDateRange/' + params.start_date + '/' + params.start_time + '/' + params.end_date + '/' + params.end_time + '/' + params.offset
            }
        }
    },
    'VIPUsage': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'VIP Usage Report',
                'uri': localStorage.getItem('server') + '/api/v5/report/sales/' + systemMode + '/vipUseByDay/' + params.daysBack
            }
        }
    },
    'VIPUsageByLocation': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'VIP Usage By Location Report',
                'uri': localStorage.getItem('server') + '/api/v5/report/sale/' + systemMode + '/' + params.location_id + '/vipCustomerByDay/' + params.daysBack
            }
        }
    },
    'RecentTransactions': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Recent Transactions By Location Report',
                'uri': localStorage.getItem('server') + '/api/v5/report/payments/' + systemMode + '/aggTrans/' + params.daysBack
            }
        }
    },
    'RecentTransactionsByLocation': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Recent Transactions Report',
                'uri': localStorage.getItem('server') + '/api/v5/report/sale/' + systemMode + '/' + params.location_id + '/salesLogLocationByDay/' + params.daysBack
            }
        }
    },
    'ItemSalesByDate': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Item Sales by Location and Date Range',
                'uri': localStorage.getItem('server') + '/api/v5/report/sales/' + systemMode + '/itemSalesByDateRange/' + startEndOffset
            }
        }
    },
    'ItemReturnsByDate': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Item Returns by Location and Date Range',
                'uri': localStorage.getItem('server') + '/api/v5/report/sales/' + systemMode + '/itemReturnsByDateRange/' + startEndOffset
            }
        }
    },
    'DetailedSales': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Detailed Sales by Location and Date Range',
                'uri': localStorage.getItem('server') + '/api/v5/report/sale/' + systemMode + '/' + params.location_id + '/getDetailedSales/' + startEndOffset
            }
        }
    },
    'SalesTaxAudit': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Sales Tax Audit',
                'uri': localStorage.getItem('server') + '/api/v5/report/payments/' + systemMode + '/aggTaxByDateRange/' + startEndOffset
            }
        }
    },
    'TransactionsByDay': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Transactions by Day',
                'uri': localStorage.getItem('server') + '/api/v5/report/payment/' + systemMode + '/' + params.location_id + '/aggTransactionsByDay/' + params.transaction + '/' + params.transaction_type + '/' + params.day + '/' + params.offset
            }
        },
    },
    'SalesComparisonByDate': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Sales Comparison',
                'uri': localStorage.getItem('server') + '/api/v5/report/payments/' + systemMode + '/salesCompByDateRange/' + startEndOffset
            }
        }
    },
    'SalesComparisonLocationByDate': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Sales Comparison Location',
                'uri': localStorage.getItem('server') + '/api/v5/report/payment/' + systemMode + '/' + params.location_id + '/salesCompByLocationDateRange/' + startEndOffset
            }
        }
    },
    'ScheduledReports': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Scheduled Reports',
                'uri': localStorage.getItem('server') + '/api/v5/report/schedules/all/' + systemMode
            }
        },
        GET_ONE: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'Scheduled Report',
                'uri': localStorage.getItem('server') + '/api/v5/report/schedule/' + systemMode + '/' + params.id
            }
        },
        CREATE: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'method': 'POST',
                'data': params.data,
                'uri': localStorage.getItem('server') + '/api/v5/report/schedule/set/' + systemMode
            }
        },
        UPDATE: function (params) {
            let systemMode = makeSystemModePath();
            const scheduledReportParams = preProcessData('ScheduledReports', 'UPDATE', params);
            return {
                'method': 'POST',
                'data': scheduledReportParams.data,
                'uri': localStorage.getItem('server') + '/api/v5/report/schedule/update/' + systemMode
            }
        }
    },
    'ReportJobs': {
        GET_LIST: function (params) {
            let system = setSystemToLowercase();
            let query = assembleReportJobQuery(params);
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Report Jobs',
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/list' + query
            }
        },
        GET_ONE: function (params) {
            let system = setSystemToLowercase();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'Report Job',
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/get/' + params.id
            }
        },
        CREATE: function (params) {
            let system = setSystemToLowercase();
            return {
                'method': 'POST',
                'data': params.data,
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/submit'
            }
        },
    },
    'ReportJobDownload': {
        GET_ONE: function (params) {
            let system = setSystemToLowercase();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'Download Report Job File',
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/download/' + params.filename
            }
        },
    },
    'ReportJobFiles': {
        GET_ONE: function (params) {
            let system = setSystemToLowercase();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'Report Job Files',
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/files/' + params.id
            }
        },
    },
    'ReportJobStatus': {
        GET_ONE: function (params) {
            let system = setSystemToLowercase();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'Report Job Status',
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/stat/' + params.filename
            }
        },
    },
    'VIPTrendsByDate': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'VIP Trends by Date Range',
                'uri': localStorage.getItem('server') + '/api/v5/report/sales/' + systemMode + '/vipTrendsReportByDateRange/' + startEndOffset
            }
        }
    },
    'VIPCustomersProductsAggregatedByLocation': {
        GET_LIST: function (params) {

            // @TODO deprecate

            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'VIP Customers and Products by Location',
                'uri': localStorage.getItem('server') + '/api/v5/report/sales/' + systemMode + '/vipCustomerProdAgg/' + startEndOffset
            }
        }
    },
    'VIPPointsAndProductsByDate': {
        GET_LIST: function (params) {

            // @TODO deprecate

            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'VIP Points and Products',
                'uri': localStorage.getItem('server') + '/api/v5/report/sales/' + systemMode + '/vipPointsAndProductsAgg/' + startEndOffset
            }
        }
    },
    'VIPCustomersByLocationAndDate': {
        GET_LIST: function (params) {

            // @TODO deprecate

            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'VIP Customers by Location',
                'uri': localStorage.getItem('server') + '/api/v5/report/sale/' + systemMode + '/' + params.location_id + '/vipByLocationDateRange/' + startEndOffset
            }
        }
    },
    'TransferItemTotals': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Transfer Item Totals',
                'uri': localStorage.getItem('server') + '/api/v5/report/transfer/' + systemMode + '/getItemTotals/' + params.transfer_id
            }
        }
    },
    'LocationLogById': {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Location Open/Close Log',
                'uri': localStorage.getItem('server') + '/api/v5/report/locationById/' + system + '/' + params.location_id + '/getLocationLog/' + params.type + '/' + startEndOffset
            }
        }
    },
    'RegisterLogByLocationId': {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let startEndOffset = params.start_date + '/' + params.end_date + '/' + params.offset;
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Register Open/Close Log by Location ID',
                'uri': localStorage.getItem('server') + '/api/v5/report/locationById/' + system + '/' + params.location_id + '/getRegisterLog/' + startEndOffset
            }
        }
    },
    'RegisterLogInfoBySeq': {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Register Log Info by Sequence',
                'uri': localStorage.getItem('server') + '/api/v5/report/locationById/' + system + '/' + params.location_id + '/getRegisterLogInfo/' + params.seq
            }
        }
    },
    'ZeroDays': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Zero Days',
                'uri': localStorage.getItem('server') + '/api/v5/report/inventory/' + systemMode + '/' + params.location_id + '/getZeroDays?params=' + JSON.stringify(params)
            }
        }
    },
    'InventoryByZeroDay': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Zero Days',
                'uri': localStorage.getItem('server') + '/api/v5/report/inventory/' + systemMode + '/' + params.location_id + '/getInvByZeroDay/' + params.zero_day + '?params=' + JSON.stringify(params)
            }
        }
    },
    'FinalAuditsByZeroDay': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Final Audits by Zero Day',
                'uri': localStorage.getItem('server') + '/api/v5/report/inventory/' + systemMode + '/' + params.location_id + '/getAuditsByZeroDay/' + params.zero_day + '/final?params=' + JSON.stringify(params)
            }
        }
    },
    'FinalAuditItems': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Final Audit Items',
                'uri': localStorage.getItem('server') + '/api/v5/report/inventory/' + systemMode + '/' + params.location_id + '/getAuditItems/' + params.audit_uuid + '?params=' + JSON.stringify(params)
            }
        }
    },
    'DefaultPricesByProductType': {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Default Prices by Location Product Type',
                'uri': localStorage.getItem('server') + '/api/v5/report/product/' + system + '/getDefaultPricesByType/' + params.product_type + '?params=' + JSON.stringify(params)
            }
        }
    },
    'SaleSummaryByZeroDay': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Sales Summary by Zero Day',
                'uri': localStorage.getItem('server') + '/api/v5/report/payment/' + systemMode + '/' + params.location_id + '/getSaleSummaryByZeroDay/' + params.zero_day + '/' + params.time_zone_offset + '?params=' + JSON.stringify(params)
            }
        }
    },
    'InventoryIncomingItemTotals': {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Inventory Incoming Item Totals',
                'uri': localStorage.getItem('server') + '/api/v5/report/transfers/' + systemMode + '/' + params.location_id + '/getIncomingItemTotals'
            }
        }
    },
    'RenderReport': {
        POST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'file',
                'method': 'POST',
                'data': params,
                'title': 'Render Report',
                'uri': localStorage.getItem('server') + '/api/v5/report/render/' + systemMode
            }
        }
    },
    'CreditCardTransactions': {
        POST: function (params) {
            let systemMode = makeSystemModePath();
            return {
                'type': 'list',
                'method': 'POST',
                'data': params,
                'title': 'Credit Card Transaction Search',
                'uri': localStorage.getItem('server') + '/api/v5/report/payments/' + systemMode + '/getCCPayments'
            }
        }
    }
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "SaleSummaryByZeroDay"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseReportsResourceMap.js